import { useEffect } from 'react';
import { toast } from 'sonner';
import { subscribePWAUpdate } from '../lib/pwa';

export default function PWAUpdateNotice() {
  useEffect(() => subscribePWAUpdate(() => {
    toast('Hay una nueva versión de MiCoach', {
      id: 'micoach-update', duration: Infinity,
      description: 'Guarda tu trabajo antes de actualizar. No necesitas reinstalar la app.',
      action: { label: 'Actualizar', onClick: () => {
        if (window.confirm('¿Has guardado tu trabajo? MiCoach se recargará para abrir la última versión.')) window.location.reload();
      } },
      cancel: { label: 'Más tarde', onClick: () => {} },
    });
  }), []);
  return null;
}
